import React, {useState, useEffect} from 'react';
import Switch from 'react-switch';
import {TarjetaEncuestaRecurrente} from './TarjetaEncuestaRecurrente';

export const EncuestasRecurrentes = (props) => {
	// Desustruturación de props
	const {} = props;

	const [Encuestas, setEncuestas] = useState([
		{
			id: 1,
			titulo: 'Encuesta 1',
			descripcion: 'Esta es la encuesta 1',
			fechaCreaccion: '2021-05-01',
			frecuencia: 'Semanal',
			estado: true,
		},
		{
			id: 2,
			titulo: 'Encuesta 2',
			descripcion: 'Esta es la encuesta 2',
			fechaCreaccion: '2021-10-12',
			frecuencia: 'Mensual',
			estado: false,
		},
		{
			id: 3,
			titulo: 'Encuesta 3',
			descripcion: 'Esta es la encuesta 3',
			fechaCreaccion: '2022-05-09',
			frecuencia: 'Diaria',
			estado: true,
		},
		{
			id: 4,
			titulo: 'Encuesta 4',
			descripcion: 'Esta es la encuesta 4',
			fechaCreaccion: '2022-4-3',
			frecuencia: 'Semanal',
			estado: false,
		},
	]);

	const elimiarEncuesta = (id) => {
		let listaAxu = Encuestas.filter((encuesta) => encuesta.id !== id);
		setEncuestas(listaAxu);

		// Hacer el delete en la bd de esa encuesta
		//
		//
	};
	const cambiarEstadoEncuesta = (id) => {
		let listaAxu = Encuestas.map((encuesta) => {
			if (encuesta.id === id) {
				encuesta.estado = !encuesta.estado;
			}
			return encuesta;
		});
		setEncuestas(listaAxu);

		// Hacer el update en la bd de esa encuesta
		//
		//
	};

	return (
		<div className='lista-encuestas-recurrentes'>
			{Encuestas.map((encuesta) => (
				<TarjetaEncuestaRecurrente
					Id={encuesta.id}
					titulo={encuesta.titulo}
					descripcion={encuesta.descripcion}
					fechaCreaccion={encuesta.fechaCreaccion}
					frecuencia={encuesta.frecuencia}
					estado={encuesta.estado}
					elimiarEncuesta={elimiarEncuesta}
					cambiarEstadoEncuesta={cambiarEstadoEncuesta}
				/>
			))}
		</div>
	);
};
